import { useBackground } from '~/composables/useBackgroundArea';

export default function (to: any, from: any) {
    if (from.path !== to.path) {
        const { resetBackground } = useBackground();
        resetBackground();
    }
}
